import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Location } from "@angular/common";
import { NavigationService } from "src/app/services/navigation.service";
import { CashBookingService } from "src/app/services/cashbooking.service";
import { MatHorizontalStepper, MatStepper } from "@angular/material/stepper";
import * as _ from "lodash";
import { DateTimeAdapter } from "ng-pick-datetime";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "src/app/services/alert.service";
import { PaccsbookingService } from "src/app/services/paccsbooking.service";
import { element } from "protractor";

import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { JUL } from "@angular/material/core";
import swal from 'sweetalert2';


@Component({
  selector: "app-paacsbookingpopup",
  templateUrl: "./paacsbookingpopup.component.html",
  styleUrls: ["./paacsbookingpopup.component.scss"],
})
export class PaacsbookingpopupComponent implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  currentStepIndex: any;
  Manufacturerlist: any;
  @ViewChild("stepper") private myStepper: MatStepper;
  subDivisionId: any;
  mhireUserFarmId: any;
  displayedColumns1: string[] = [
    "productName",
    "manufacturerName",
    "noOfMachinery",
    "totalcost",
    "Subsidyamount",
    "dealerName",
    "action",
  ];
  data: any = [];
  data1: any = [];
  dataSource = new MatTableDataSource(this.data);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;
  productname: any;
  popupimageslist: any;
  environment: string;
  machineryList: any;
  machineryListCount: any[] = [];
  productImages: any;
  dealerlist: any;
  dealerdata: any;
  dealerselectedid: any;
  isdisabled: boolean = true;
  imageBaseUrl: string;
  totalvehiclecount = 0;
  productid: any;
  selectedproductlist: any;
  itemValues: number[][] = [];
  loader: boolean = false;
  addMachineList: any[] = [];
  filtredMachineList: any[];
  resultdata: any;
  manufacturerList: any[];
  manufacturerListCopy: any[];
  Form: any;
  classificationList: any[];
  classificationListCopy: any[];
  categoryTypeList: any[];
  categoryTypeListCopy: any[];
  filterImplementList: any[];
  ImplementList: any[];
  component: any;
  click: boolean = false;
  allsave: boolean = true;
  paccsEventType: any;
  manufactureType: any;
  classification: any;
  machineCategory: any;
  productId: any;
  manufacturerTypeName: any[];
  machinaryClassificationName: any[];
  machinaryCategoryName: any[];
  productCategoryName: any[];
  showlable: boolean;
  bookinglist: any[] = [];
  Excbookinglist: any[] = [];
  nextdisable: boolean = true;
  id: number;
  row: number;
  col: number;
  totalMachinaryCount: number;
  totalCost: number;
  subsidyAmount: number;
  selectedProduct: any;
  indicesToRemove: any[] = [];
  shouldSkipStep1: boolean = false;
  selecteddealerName: any;
  selecteddealerId: any;
  // itemValues: number[][] = [];
  totalcount: number = 0;
  financialYearId: any;
  goId: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public dialogRef: MatDialogRef<PaacsbookingpopupComponent>,
    private _formBuilder: FormBuilder,
    private _location: Location,
    private translate: TranslateService,
    public cashBookingService: CashBookingService,
    public navigationService: NavigationService,
    private modalService: NgbModal,
    private alertService: AlertService,
    private paccsbookingService: PaccsbookingService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) {
    (this.productid = this.dataRecievedData.productid),
      dateTimeAdapter.setLocale("en-IN");
    this.component = this.dataRecievedData.dbtComponentId;
    this.paccsEventType = this.dataRecievedData.paccsEventType
    this.manufactureType = this.dataRecievedData.manufacturerType;
    this.classification = this.dataRecievedData.machinaryClassificationId;
    this.machineCategory = this.dataRecievedData.machinaryCategoryId;
    this.productId = this.dataRecievedData.dbtProductId;
    this.bookinglist = this.dataRecievedData.bookinglist;


    const originalArray = this.dataRecievedData.bookinglist;
    this.Excbookinglist = this.deepClone(originalArray);
  }

  deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (Array.isArray(obj)) {
      const newArr = [];
      for (let i = 0; i < obj.length; i++) {
        newArr[i] = this.deepClone(obj[i]);
      }
      return newArr;
    }

    const newObj = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = this.deepClone(obj[key]);
      }
    }
    return newObj;
  }

  ngOnInit() {
    this.FormGroup();

    this.imageBaseUrl = environment.imageBaseUrl + "DBT/ProductImage/";
    this.component = this.dataRecievedData.dbtComponentId;
    this.paccsEventType = this.dataRecievedData.paccsEventType
    this.manufactureType = this.dataRecievedData.manufacturerType;
    this.classification = this.dataRecievedData.machinaryClassificationId;
    this.machineCategory = this.dataRecievedData.machinaryCategoryId;
    this.productId = this.dataRecievedData.dbtProductId;
    this.financialYearId = this.dataRecievedData.financialYearId;
    this.goId = this.dataRecievedData.dbtGoId;
    this.getmanufacturerList();
    if (this.paccsEventType == 1) {
      this.showlable = true;
      this.manufacturerTypeName = this.dataRecievedData.manufacturerTypeName
      this.machinaryClassificationName = this.dataRecievedData.machinaryClassificationName
      this.machinaryCategoryName = this.dataRecievedData.machinaryCategoryName
      this.productCategoryName = this.dataRecievedData.data.dealerName
      this.shouldSkipStep1 = true
      this.getEditList()

    }
    else {
      this.getmanufacturerList();

    }
  }

  FormGroup() {
    this.firstFormGroup = this._formBuilder.group({
      vehiclecount: [0, Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({});
    this.thirdFormGroup = this._formBuilder.group({
      manufacturerType: ["", Validators.required],
      classification: ["", Validators.required],
      categoryType: ["", Validators.required],
      productId: ["", Validators.required],
    });
  }
  openPopup(showImage: any, list: any) {
    this.productname = list.productName;
    this.popupimageslist = list.image;
    this.modalService.open(showImage, { centered: true });
  }

  getEditList() {
    this.paccsbookingService
      .getproductlistbymanufacturer(this.component,
        this.dataRecievedData.productid,
        this.financialYearId,
        true
      )
      .subscribe((res) => {
        if (res.length > 0) {
          this.machineryList = res;
          this.machineryListCount = res;


          this.loader = false;
          this.machineryListCount.forEach((element) => {
            const rowValues: number[] = [];
            element.productList.forEach((element) => {
              rowValues.push(0);
            });
            this.itemValues.push(rowValues);
          });
          for (let i = 0; i < this.machineryListCount.length; i++) {
            for (let j = 0; j < this.machineryListCount[i].productList.length; j++) {
              if (this.machineryListCount[i].id == this.dataRecievedData.data.dbtManufacturerId) {
                if (this.machineryListCount[i].productList[j].dbtProductInfoId == this.dataRecievedData.data.dbtProductInfoId) {
                  this.itemValues[i][j] = this.dataRecievedData.data.totalMachinaryCount
                  this.row = i;
                  this.col = j
                  this.firstFormGroup.controls['vehiclecount'].setValue(this.itemValues[i][j])
                  this.totalcount = this.itemValues[i][j];
                }
              }
            }
          }

          this.machineryListCount = this.machineryListCount.filter(x => x.id == this.dataRecievedData.data.dbtManufacturerId);
          this.machineryListCount.forEach(element => {
            element.productList = element.productList.filter(x => x.dbtProductInfoId == this.dataRecievedData.data.dbtProductInfoId)
          });
          this.addMachineList = this.machineryListCount[0].productList;
          this.addMachineList.forEach(element => {
            element.totalSubsidyAmount = this.dataRecievedData.data.totalSubsidyAmount
            element.totalMachinaryCount = this.dataRecievedData.data.totalMachinaryCount
            element.totalCost = this.dataRecievedData.data.totalCost
            element.contributionAmount = this.dataRecievedData.data.contributionAmount
            element.productName = this.dataRecievedData.data.productName;
            element.child = this.dataRecievedData.data.child;

          });


        }

      });

  }


  getmanufacturerList() {
    this.manufacturerList = [];
    this.manufacturerListCopy = [];
    this.paccsbookingService
      .getManufacturerList(this.financialYearId, this.goId,this.component, true)
      .subscribe((result) => {
        if (result) {
          this.manufacturerList = result;
          this.manufacturerListCopy = this.manufacturerList;
          this.manufacturerListCopy = this.manufacturerListCopy.slice();
          if (this.paccsEventType == 0) {
            if (this.manufacturerListCopy.length === 1) {
              this.thirdFormGroup.controls["manufacturerType"].setValue(
                this.manufacturerListCopy[0].key
              );
              this.getClassificationList();
            }
          }
          else {
            this.thirdFormGroup.controls['manufacturerType'].setValue(this.manufactureType);
            this.getClassificationList();

          }
        }
      });
  }
  getClassificationList() {
    this.classificationList = [];
    this.classificationListCopy = [];
    this.categoryTypeList = [];
    this.categoryTypeListCopy = [];
    this.ImplementList = [];
    this.filterImplementList = [];
    this.thirdFormGroup.controls["classification"].setValue(null);
    this.thirdFormGroup.controls["categoryType"].setValue(null);
    this.thirdFormGroup.controls["productId"].setValue(null);
    this.paccsbookingService
      .getMachinaryClassificationList(
        this.financialYearId, this.goId,
        this.component,
        this.thirdFormGroup.value.manufacturerType,
        true
      )
      .subscribe((result) => {
        if (result) {
          this.classificationList = result;
          this.classificationListCopy = this.classificationList;
          this.classificationListCopy = this.classificationListCopy.slice();
          if (this.paccsEventType == 0) {
            if (this.classificationListCopy.length === 1) {
              this.thirdFormGroup.controls["classification"].setValue(
                this.classificationListCopy[0].key
              );
              this.getCategoryType(this.thirdFormGroup.value.classification);
            }
          } else {
            this.thirdFormGroup.controls['classification'].setValue(this.classification)
            this.getCategoryType(this.thirdFormGroup.value.classification);

          }
        }
      });
  }

  getCategoryType(event: any) {
    this.categoryTypeList = [];
    this.categoryTypeListCopy = [];
    this.ImplementList = [];
    this.filterImplementList = [];
    this.thirdFormGroup.controls["categoryType"].setValue(null);
    this.thirdFormGroup.controls["productId"].setValue(null);
    this.paccsbookingService
      .getmachinarycategory(
        this.financialYearId, this.goId,
        this.component,
        this.thirdFormGroup.value.manufacturerType,
        this.thirdFormGroup.value.classification,
        true
      )
      .subscribe((result) => {
        if (result) {
          this.categoryTypeList = result;
          this.categoryTypeListCopy = this.categoryTypeList;
          this.categoryTypeListCopy = this.categoryTypeListCopy.slice();
          this.categoryTypeListCopy = _.orderBy(
            this.categoryTypeListCopy,
            ["value"],
            ["asc"]
          );
          if (this.paccsEventType == 0) {
            if (this.categoryTypeListCopy.length === 1) {
              this.thirdFormGroup.controls["categoryType"].setValue(
                this.categoryTypeListCopy[0].key
              );
              this.componentListChange(this.thirdFormGroup.value.categoryType);
            }
          }
          else {
            this.thirdFormGroup.controls["categoryType"].setValue(
              this.machineCategory
            );
            this.componentListChange(this.thirdFormGroup.value.categoryType);

          }
        }
      });
  }

  componentListChange(event: any) {
    this.ImplementList = [];
    this.filterImplementList = [];
    this.thirdFormGroup.controls["productId"].setValue(null);
    this.paccsbookingService
      .getproductlist(
        this.financialYearId,
        this.goId,
        this.component,
        this.thirdFormGroup.value.manufacturerType,
        this.thirdFormGroup.value.categoryType,
        true
      )
      .subscribe((result) => {
        this.ImplementList = [];
        this.ImplementList = result;
        this.filterImplementList = result;
        this.filterImplementList = _.orderBy(
          this.filterImplementList,
          ["value"],
          ["asc"]
        );
        if (this.paccsEventType != 0) {
          this.thirdFormGroup.controls['productId'].setValue(this.productid)
        }
        if (this.filterImplementList.length == 1) {
          this.thirdFormGroup.controls["productId"].setValue(
            this.filterImplementList[0].key
          );
          this.click = true;
        }
      });
  }
  productChange() {
    this.click = true;
  }

  validateFirstFormControl() {
    Object.keys(this.firstFormGroup.controls).forEach((field) => {
      const control = this.firstFormGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  validateThirdFormControl() {
    Object.keys(this.thirdFormGroup.controls).forEach((field) => {
      const control = this.thirdFormGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  validateSecondFormControl() {
    Object.keys(this.secondFormGroup.controls).forEach((field) => {
      const control = this.secondFormGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  selectDealer() {
    if (this.paccsEventType == 0) {
      this.myStepper.selectedIndex = 2;  


    }
    else {
      this.myStepper.selectedIndex = 1
    }
    if (this.paccsEventType == 2) {
      this.myStepper.selectedIndex = 2

    }

    // this.getdealerlist(item,list);
    // (this.Manufacturerlist = item), (this.selectedproductlist = list);
    this.filtredMachineList = this.addMachineList.filter(x => x.totalMachinaryCount != 0);
    // this.filtredMachineList.forEach(ele => {
    //   ele.child.forEach(element => {
    //     element.child=null;

    //   });
    // });
    if (this.paccsEventType != 0) {
      this.filtredMachineList.forEach((x) => {
        x.dealerName = this.dataRecievedData.data.dealerName,
          x.dbtDealerId = this.dataRecievedData.data.dbtDealerId
      }
      )
    }
    else {
      if (this.paccsEventType == 0){
        this.loader = true;
        this.filtredMachineList.forEach((x) => {
          let data = {
                dbtManufacturerId: x.dbtManufacturerId,
                dbtProductId: x.dbtProductInfoId,
              };
              this.paccsbookingService.getdealerlist(data, true).subscribe((res) => {
                this.dealerlist = res;
                if(this.dealerlist.length == 1){
                      x.dealerName = this.dealerlist[0]?.organisationName;
                      x.dbtDealerId = this.dealerlist[0]?.id;        
                      this.isdisabled = false;
                }  
                this.loader = false;
              });
  
        })
      }
      this.filtredMachineList.forEach((x) => {
        x.id = 0

      }
      )
    }
    this.totalMachinaryCount = _.sumBy(this.filtredMachineList, 'totalMachinaryCount'),
      this.totalCost = _.sumBy(this.filtredMachineList, 'totalCost'),
      this.subsidyAmount = _.sumBy(this.filtredMachineList, 'totalSubsidyAmount'),
      this.dataSource = new MatTableDataSource(this.filtredMachineList);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  selectDealerlist(showdealerdetails: any, resultdata: any) {
    this.getdealerlist(resultdata);
    this.modalService.open(showdealerdetails, { centered: true });
    this.resultdata = resultdata;
  }

  spliceProduct() {
    this.itemValues = []
    this.machineryListCount.forEach((element) => {
      const rowValues: number[] = [];
      element.productList.forEach((element) => {
        rowValues.push(0);
      });
      this.itemValues.push(rowValues);
    });
    for (let i = 0; i < this.machineryListCount.length; i++) {
      for (let j = 0; j < this.machineryListCount[i].productList.length; j++) {
        this.bookinglist.forEach(element => {
          if (this.machineryListCount[i].productList[j].dbtProductInfoId == element.dbtProductInfoId) {
            // Push the indices of matching elements as an object
            this.indicesToRemove.push({ row: i, col: j });
          }
        });

      }
    }
    if (this.indicesToRemove.length > 0) {
      // Iterate in reverse order to avoid issues when splicing
      for (let i = this.indicesToRemove.length - 1; i >= 0; i--) {
        const { row, col } = this.indicesToRemove[i];
        if (this.machineryListCount[row].productList.length == 0) {
          this.machineryListCount.splice(row, 1)
        }
        this.machineryListCount[row].productList.splice(col, 1)

        // this.machineryListCount[row].splice(col, 1);

        // this.machineryListCount[row].splice(col, 1);
      }

      if (this.indicesToRemove.length > 0) {
        // Iterate in reverse order to avoid issues when splicing
        for (let i = this.indicesToRemove.length - 1; i >= 0; i--) {
          const { row, col } = this.indicesToRemove[i];
          if (this.machineryListCount[row].productList.length == 0) {
            this.machineryListCount.splice(row, 1)
          }
          // this.machineryListCount[row].productList.splice(col,1)


        }
      
      }



    }
    // const index = this.filterImplementList.findIndex(element => element === targetValue);
  }

  getMachineryList() {
    this.machineryList = [];
    // this.machineryListCount = [];
    this.totalcount = 0;
    if (this.paccsEventType != 0) {
      this.click = true
    }

    if (this.thirdFormGroup.valid && this.nextdisable) {

      this.manufacturerTypeName = this.manufacturerList.filter(
        (i) => i.key == this.thirdFormGroup.value.manufacturerType
      );
      this.machinaryClassificationName = this.classificationList.filter(
        (i) => i.key == this.thirdFormGroup.value.classification
      );
      this.machinaryCategoryName = this.categoryTypeList.filter(
        (i) => i.key == this.thirdFormGroup.value.categoryType
      );
      this.productCategoryName = this.filterImplementList.filter(
        (i) => i.key == this.thirdFormGroup.value.productId
      );
      this.myStepper.selectedIndex = 1;
      this.showlable = true;
      this.loader = true;
      if (this.click) {
        this.paccsbookingService
          .getproductlistbymanufacturer(this.component,
            this.thirdFormGroup.value.productId,
            this.financialYearId,
            true
          )
          .subscribe((res) => {
            if (res.length > 0) {
              this.machineryList = res;
              this.machineryListCount = res;
              if (this.paccsEventType == 0) {
                this.addMachineList = []
                this.itemValues = []

                this.machineryListCount.forEach((element) => {
                  const rowValues: number[] = [];
                  element.productList.forEach((element) => {
                    rowValues.push(0);
                  });
                  this.itemValues.push(rowValues);
                });

                this.loader = false;
                if (this.bookinglist.length > 0) {
                  this.bookinglist.forEach(element => {
                    if (element.dbtProductId == this.thirdFormGroup.value.productId) {
                      this.spliceProduct();

                    }
                  });
                }
              }
              else {
                this.loader = false;
                this.machineryListCount.forEach((element) => {
                  const rowValues: number[] = [];
                  element.productList.forEach((element) => {
                    rowValues.push(0);
                  });
                  this.itemValues.push(rowValues);
                });
                for (let i = 0; i < this.machineryListCount.length; i++) {
                  for (let j = 0; j < this.machineryListCount[i].productList.length; j++) {
                    if (this.machineryListCount[i].id == this.dataRecievedData.data.dbtManufacturerId) {
                      if (this.machineryListCount[i].productList[j].dbtProductInfoId == this.dataRecievedData.data.dbtProductInfoId) {
                        this.itemValues[i][j] = this.dataRecievedData.data.totalMachinaryCount
                        this.row = i;
                        this.col = j
                        this.firstFormGroup.controls['vehiclecount'].setValue(this.itemValues[i][j])
                        this.totalcount = this.itemValues[i][j];

                      }
                    }
                  }
                }

                this.machineryListCount = this.machineryListCount.filter(x => x.id == this.dataRecievedData.data.dbtManufacturerId);
                this.machineryListCount.forEach(element => {
                  element.productList = element.productList.filter(x => x.dbtProductInfoId == this.dataRecievedData.data.dbtProductInfoId)
                });
                this.addMachineList = this.machineryListCount[0].productList;
                this.addMachineList.forEach(element => {
                  element.totalSubsidyAmount = this.dataRecievedData.data.totalSubsidyAmount
                  element.totalMachinaryCount = this.dataRecievedData.data.totalMachinaryCount
                  element.totalCost = this.dataRecievedData.data.totalCost
                  element.contributionAmount = this.dataRecievedData.data.contributionAmount
                  element.productName = this.dataRecievedData.data.productName;

                });

              }
            }

          });
      } else {
        this.loader = false;
      }
    } else {
      this.loader = false;

      this.validateThirdFormControl();
    }


  }
  getdealerlist(resultdata) {
    let data = {
      dbtManufacturerId: resultdata.dbtManufacturerId,
      dbtProductId: resultdata.dbtProductInfoId,
    };
    this.loader = true;
    this.paccsbookingService.getdealerlist(data, true).subscribe((res) => {
      this.dealerlist = res;
      this.dealerlist.forEach((element) => {
        if (resultdata.dealerName == element.organisationName) {
          this.selecteddealerName = element?.organisationName;
          this.selecteddealerId = element?.id;
          this.isdisabled = false;
        }
      })

      this.loader = false;
    });
  }

  seasonalcropchange1(list: any) {
    this.dealerdata = list;
    this.dealerselectedid = this.dealerdata.id;
    this.selecteddealerName = this.dealerdata.organisationName;
    this.selecteddealerId = this.dealerdata.id;

    this.allsave = true;
    if (this.dealerselectedid !== 0) {
      this.isdisabled = false;
    } else {
      this.isdisabled = true;
    }
  }
  dealersave() {
    this.resultdata.dealerName = this.selecteddealerName;
    this.resultdata.dbtDealerId = this.selecteddealerId;
    this.modalService.dismissAll();
  }
  previous(event) {
    this.click = false;
    if (this.paccsEventType == 1) {
      this.myStepper.selectedIndex = event - 1;
    }
    else {
      this.myStepper.selectedIndex = event;

    }
    this.machineryListCount.forEach((element) => {
      element.productList;
      if (this.myStepper.selectedIndex != 0) {
        this.showlable = true;
      } else {
        this.showlable = false;
      }
    });
    if (event == 0) {
      this.showlable = false;
    } else {
      this.showlable = true;
    }
  }

  increment(i, j) {
    this.totalcount = this.totalcount + 1;
    this.machineryListCount[i].productList[j].child = [];
    var x = true;
    let count = 0;
    const child = { ...this.machineryListCount[i].productList[j] };
    let parent = { ...this.machineryListCount[i].productList[j] };
    let parentchild = [];

    if (this.paccsEventType == 1)//edit
    {
      this.itemValues[this.row][this.col] = this.itemValues[this.row][this.col] + 1
      this.firstFormGroup.controls['vehiclecount'].setValue(this.itemValues[this.row][this.col])
      count = this.itemValues[this.row][this.col]
      this.bookinglist.forEach(element => {
        if (element.dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
          parentchild = element.child
        }
      });
      let addItem = child;
      addItem.id = 0
      addItem.unitTotalMachinaryCount = 1;
      addItem.unitTotalSubsidyAmount = addItem.subsidyAmount
      addItem.unitTotalCost = addItem.price
      parentchild.push(addItem)
    }
    else {
      this.itemValues[i][j] = this.itemValues[i][j] + 1;
      count = this.itemValues[i][j];
    }

    this.addMachineList.forEach((row) => {
      if (row.dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
        x = false;
      }
    });

    if (this.paccsEventType == 0) {
      for (let x = 0; x < count; x++) {
        parentchild.push(child);
      }
      parentchild.forEach(element => {
        element.unitTotalMachinaryCount = 1;
        element.unitTotalSubsidyAmount = element.subsidyAmount
        element.unitTotalCost = element.price
        element.id = 0
      });
    }

    parent.child = parentchild;
    if (x) {
      this.addMachineList.push(parent);
    } else {
      this.addMachineList.forEach((row) => {
        if (row.dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
          row.child = parentchild;
        }
      });
    }

    this.addMachineList.forEach((element) => {
      if (element.dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
        if (this.paccsEventType == 0) {
          element.totalMachinaryCount = this.itemValues[i][j];
        }
        else {
          element.totalMachinaryCount = this.itemValues[this.row][this.col];
        }
        element.totalCost = parseInt(element.totalMachinaryCount) * parseInt(element.price);
        element.totalSubsidyAmount = parseInt(element.totalMachinaryCount) * parseInt(element.subsidyAmount);
        element.contributionAmount = parseInt(element.totalCost) - parseInt(element.subsidyAmount);
      }
    });


  }
  decrement(i, j) {
    var x = true;
    let count = 0;
    const child = { ...this.machineryListCount[i].productList[j] };
    let parent = { ...this.machineryListCount[i].productList[j] };
    let parentchild = [];

    if (this.paccsEventType == 1)//edit
    {
      if (this.itemValues[this.row][this.col] > 0) {
        this.itemValues[this.row][this.col]--

        this.firstFormGroup.controls['vehiclecount'].setValue(this.itemValues[this.row][this.col])
        count = this.itemValues[this.row][this.col]
        if (this.totalcount > 0) { this.totalcount--; }

      }
    }
    else if (this.itemValues[i][j] > 0) {
      this.itemValues[i][j]--;
      count = this.itemValues[i][j]
      if (this.totalcount > 0) { this.totalcount--; }

    }

    if (this.paccsEventType == 0) {
      for (let a = 0; a < this.addMachineList.length; a++) {
        if (this.addMachineList[a].dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
          this.addMachineList[a].child.splice(a, 1);
        }
      };
      for (let x = 0; x < count; x++) {
        parentchild.push(child)
      }

      parentchild.forEach(element => {
        element.unitTotalMachinaryCount = 1;
        element.unitTotalSubsidyAmount = element.subsidyAmount
        element.unitTotalCost = element.price
        if (this.paccsEventType == 0) {
          element.id = 0
        }
      });
    } else {
      for (let a = 0; a < this.bookinglist.length; a++) {
        if (this.bookinglist[a].dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
          parentchild = this.bookinglist[a].child
        }
      };
      parentchild.pop();
    }


    parent.child = parentchild;
    this.addMachineList.forEach((element) => {
      if (element.dbtProductInfoId == this.machineryListCount[i].productList[j].dbtProductInfoId) {
        if (this.paccsEventType == 0) {
          element.totalMachinaryCount = this.itemValues[i][j];
        }
        else {
          element.totalMachinaryCount = this.itemValues[this.row][this.col];
        }
        element.totalCost = parseInt(element.totalMachinaryCount) * parseInt(element.price);
        element.totalSubsidyAmount = parseInt(element.totalMachinaryCount) * parseInt(element.subsidyAmount);
        element.contributionAmount = parseInt(element.totalCost) - parseInt(element.subsidyAmount);
      }
    });

  }


  deleteProduct(index) {
    const title = 'Confirmation';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire(
      {
        title,
        text: 'Do you want to remove this Model?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          let del = this.addMachineList.splice(index, 1)
          this.filtredMachineList.splice(index, 1)
          this.totalMachinaryCount = _.sumBy(this.filtredMachineList, 'totalMachinaryCount'),
            this.totalCost = _.sumBy(this.filtredMachineList, 'totalCost'),
            this.subsidyAmount = _.sumBy(this.filtredMachineList, 'totalSubsidyAmount'),
            this.dataSource = new MatTableDataSource(this.filtredMachineList);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          for (let i = 0; i < this.machineryListCount.length; i++) {
            for (let j = 0; j < this.machineryListCount[i].productList.length; j++) {
              if (this.machineryListCount[i].id == del[0].dbtManufacturerId) {
                if (this.machineryListCount[i].productList[j].dbtProductInfoId == del[0].dbtProductInfoId) {
                  this.totalcount = this.totalcount - this.itemValues[i][j];
                  this.itemValues[i][j] = 0
                  // this.firstFormGroup.controls['vehiclecount'].setValue(this.dataRecievedData.data.totalMachinaryCount)

                }
              }
            }
          }
        }
      });

  }
  toapply() {
    this.myStepper.selectedIndex = 2;
  }

  moveToStep(stepIndex: number): void {
    this.myStepper.selectedIndex = stepIndex;
  }
  save() {
    this.allsave = true;
    let data = this.filtredMachineList;
    if (this.firstFormGroup.valid) {
      data.forEach((a) => {
        if (a.dbtDealerId) {
          (a.manufacturerType = this.thirdFormGroup.value.manufacturerType),
            (a.manufacturerTypeName = this.paccsEventType == 0 ? this.manufacturerTypeName[0].value : this.manufacturerTypeName),
            (a.machinaryClassificationId =
              this.thirdFormGroup.value.classification),
            (a.machinaryClassificationName = this.paccsEventType == 0 ?
              this.machinaryClassificationName[0].value : this.machinaryClassificationName),
            (a.machinaryCategoryId = this.thirdFormGroup.value.categoryType),
            (a.machinaryCategoryName = this.paccsEventType == 0 ? this.machinaryCategoryName[0].value : this.machinaryCategoryName),
            (a.dbtProductId = this.thirdFormGroup.value.productId),
            (a.dbtProductInfoId = a.dbtProductInfoId);
          a.dbtProductName = this.paccsEventType == 0 ? this.productCategoryName : this.productCategoryName
          a.event = 1
          a.child.forEach((c) => {
            c.dbtDealerId = a.dbtDealerId,
              (c.manufacturerType = this.thirdFormGroup.value.manufacturerType),
              (c.manufacturerTypeName = this.paccsEventType == 0 ? this.manufacturerTypeName[0].value : this.manufacturerTypeName),
              (c.machinaryClassificationId =
                this.thirdFormGroup.value.classification),
              (c.dealerName = a.dealerName),
              (c.machinaryClassificationName = this.paccsEventType == 0 ?
                this.machinaryClassificationName[0].value : this.machinaryClassificationName),
              (c.machinaryCategoryId = this.thirdFormGroup.value.categoryType),
              (c.machinaryCategoryName = this.paccsEventType == 0 ? this.machinaryCategoryName[0].value : this.machinaryCategoryName),
              (c.dbtProductId = this.thirdFormGroup.value.productId),
              (c.dbtProductInfoId = c.dbtProductInfoId);
            c.dbtProductName = this.paccsEventType == 0 ? this.productCategoryName : this.productCategoryName
            c.event = 1
          });
        } else {
          this.alertService.error("Dealer selection pending for selected Models");
          this.allsave = false;
        }
      });

      if (this.allsave) {
        this.dialogRef.close(data);
      }
    } else {
      this.validateFirstFormControl();
    }
  }
  cancel() {
    // if (this.paccsEventType != 0) {
    this.bookinglist = this.Excbookinglist;
    // }
    // this.bookinglist.forEach(element => {
    //   element.child = element.child.filter(a => a.eligibleSubsityAmount > 0)
    // })
    if (this.paccsEventType != 0) {
      this.dialogRef.close(this.bookinglist);
    } else {
      this.dialogRef.close();
    }
  }
}
